export default __webpack_public_path__ + "static/media/3.ec00d757.mp4";